import { type GameSettings, type WorldGeneration, type ModSpecifier } from '@mcpanel/core';
import { Accordion } from '../components/Accordion';
import { HeapFields } from '../components/HeapFields';
import { GameSettingsFields } from '../components/GameSettingsFields';
import { WorldGenerationFields } from '../components/WorldGenerationFields';
import { PlacementFields } from '../components/PlacementFields';
import type { CreateResources } from './CreateResourceFields';

type Props = {
  gameSettings: GameSettings;
  setGameSettings: (value: GameSettings) => void;
  worldGeneration: WorldGeneration;
  setWorldGeneration: (value: WorldGeneration) => void;
  candidates?: Array<{ id: string; label: string }>;
  mods: ModSpecifier[];
  resources: CreateResources;
  heapKey: string;
  heapValid: boolean;
  onHeapChange: (heap: { heapMb: number; heapMinMb: number }) => void;
  weight: 'heavy' | 'light';
  setWeight: (value: 'heavy' | 'light') => void;
  preferredNode?: string;
  setPreferredNode: (value: string | undefined) => void;
  ha: boolean;
  setHa: (value: boolean) => void;
};
export function CreateAdvancedFields({
  gameSettings,
  setGameSettings,
  worldGeneration,
  setWorldGeneration,
  candidates,
  mods,
  resources,
  heapKey,
  heapValid,
  onHeapChange,
  weight,
  setWeight,
  preferredNode,
  setPreferredNode,
  ha,
  setHa,
}: Props) {
  return (
    <Accordion title="詳しい設定" headingLevel={2}>
      <WorldGenerationFields
        candidates={candidates}
        value={worldGeneration}
        onChange={setWorldGeneration}
        mods={mods}
      />
      <section className="card card-body stack">
        <h2>ゲーム設定</h2>
        <GameSettingsFields value={gameSettings} onChange={setGameSettings} />
      </section>

      <section className="card card-body stack">
        <h2>ヒープ</h2>
        <HeapFields unit="GB" key={heapKey} value={resources} onChange={onHeapChange} />
        {!heapValid && (
          <div className="alert danger">
            ヒープは 512MB ≦ 最小 ≦ 最大 &lt; VM メモリにしてください（OS と Java 本体の分が必要です）。
          </div>
        )}
      </section>

      <section className="card card-body stack" style={{ gap: 10 }}>
        <h2>運用</h2>
        <PlacementFields
          weight={weight}
          preferredNode={preferredNode}
          onChange={(w, n) => {
            setWeight(w);
            setPreferredNode(n);
          }}
        />
        <label className="check">
          <input type="checkbox" checked={ha} onChange={(e) => setHa(e.target.checked)} />
          HA（ノードが落ちたら別のノードで自動的に起動し直す）
        </label>
      </section>
    </Accordion>
  );
}
